import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Doughnut } from 'react-chartjs-2';
import { findKey, isEmpty, size } from "lodash";

import { Grid, List, ListItem, ListItemText, ListItemSecondaryAction, Divider, ListItemAvatar, Typography, Box, Button, ButtonGroup } from '@mui/material';
import Currency from '../common/Currency';
import { FiberManualRecord } from '@mui/icons-material';
import { getLimitDate } from './statsFunctions';
import { COLORS } from '../common/ColorPicker';
import PostSingle from '../Admin/Incomes/PostSingle';
import BankSingle from '../Admin/Banks/BankSingle';

class DoughnutChart extends Component{
	state = {
		selectedPost: "",
		incomes:{},
		income_bank: "ALL",
		title: this.props.fieldBy === "income_bank" ? "Recettes par Banques" : "Recettes par Postes"

	}

	filterData = () => {
		const { filter_period, filter_payment, INCOMES, start_date, end_date } = this.props;
		let from = filter_period === "custom" ? start_date :  getLimitDate(filter_period)
		let list = this.filterDate(Object.values(INCOMES), from, end_date)
		if ( filter_payment && filter_payment !== "all" ) {
			list = this.filterPayment(list, filter_payment)
		}
		
		console.log('====================================');
		console.log({list});
		console.log('====================================');
		return list
	}

	filterDate = (list, from, to ) => {
		if(!to){
			to = Date.now()
		}
		console.log('====================================');
		console.log({list, from, to});
		console.log('====================================');
		new Date(from).setHours(0,0,0,0)
		new Date(to).setHours(0,0,0,0)

		let filteredList = Object.values(list).filter( income => 
			new Date(income.income_date) >= from 
			&& new Date(income.income_date) <= to
		)

		return filteredList
	}
	filterPayment = (list, filter_payment) => {
		let fully_paid = filter_payment === "spent" ? true : false; 

		let filteredList = list.filter( income => 
			income.income_spent === fully_paid 
		)

		return filteredList
	}

	// filterBank = (list, bankID) => {
	//     return list.filter( income => (
	// 		income.income_bank === bankID
	// 	))
	// }
	
	groupBy = (array) => {
		const { BANKS, POSTS, fieldBy, fieldName } = this.props;

		let LIST = fieldBy === "income_post" ? Object.assign({}, POSTS) : Object.assign({}, BANKS)
		return array.reduce((acc, obj) => {
			var key = LIST[obj[fieldBy]][fieldName]

			if(!acc[key]){
				acc[key] = [];
			}
			acc[key].push(obj);
			return acc;
		}, {});
	}
	sum = (array, amountField = "income_amount") => {
		const { BANKS, POSTS, fieldBy, fieldName } = this.props;

		let LIST = fieldBy === "income_post" ? Object.assign({}, POSTS) : Object.assign({}, BANKS)
		return array.reduce((acc, obj) => {
			var key = LIST[obj[fieldBy]][fieldName]

			if(!acc[key]){
				acc[key] = 0;
			}
			acc[key] += parseFloat(obj[amountField]);
			return acc;
		}, {});
	}

	
	calcData = () => {
	
		let catLabels = []
		let payment_data = []
		let total = 0
		let bckg = []
		let orderedlistSum = {}
		let otherSum = 0
		let otherQty = 0
		let list = this.filterData()

		let listSum = this.sum(list)
		let listQty = this.groupBy(list)

		if(!isEmpty(listSum) ){
			let orderedList = Object.keys(listSum).sort((a, b) => listSum[a] - listSum[b] ).reverse()
			
			total = Object.values(listSum).reduce((a, b) => a + b)
			
			// catLabels = 
			orderedList.map((itemName, i) => {
				
				if ( Math.round(listSum[itemName] / total * 100) < 1){
					console.log('=================(listSum[itemName])===================');
					console.log(listSum[itemName], otherSum);
					console.log('====================================');
					otherSum += listSum[itemName]
					otherQty += listQty[itemName]
					delete listQty[itemName]
					delete listSum[itemName]

				} else {
					bckg.push(COLORS[i*2])
					orderedlistSum[itemName] = listSum[itemName]
					
					catLabels.push(itemName)
				}
			})

			if (otherSum > 0) {
				orderedlistSum["Autres"] = otherSum
				listSum["Autres"] = otherSum
				listQty["Autres"] = otherQty
				bckg.push("grey")
				catLabels.push("Autres Catégories")
			}

			payment_data = Object.values(orderedlistSum)
			
			console.log({
				catLabels, 
				payment_data,
				listSum,
				listQty,
				orderedList,
				orderedlistSum,
				total,
			});     
		}

		return {
			catLabels, 
			payment_data,
			bckg,
			listSum: orderedlistSum,
			listQty,
			total
		}
	}
	handleChange = (e) => {
		const { name, value } = e.target
		this.setState({
			[name]: value
		})
	}
	handleClose = () => {
		this.setState({ 
            openDetails: false,
            selectedPost: {},
        });
    };   
	render(){
		console.log("CHARTS PROPS", this.props);
		const { POSTS, INCOMES, BANKS, view, fieldBy, fieldName } = this.props;
		const { openDetails, selectedPost} = this.state;

		let LIST = fieldBy === "income_post" ? Object.assign({}, POSTS) : Object.assign({}, BANKS)
		let infos = {
			catLabels: [], 
			payment_data: [],
			bckg:[],
			listSum: {}, // {IDcat: sum}
			listQty: {}, // {IDcat: qtyTransaction}
			total: 0
		}
		
		if(!isEmpty(INCOMES) && !isEmpty(LIST) ){
			infos = this.calcData()
		}

		const { catLabels, payment_data, bckg, listSum, listQty, total } = infos;
		const data = {
			labels: catLabels,
			datasets:[
				{
					label:'Répartion des Recettes',
					data:payment_data,
					backgroundColor:bckg,
				}
			]
		}
				
		return (
			<div>
				{openDetails && !isEmpty(selectedPost) && fieldBy === "income_post" &&
                    <PostSingle
                        post={selectedPost} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                        budget_year={this.props.searchYear}
                    />
                }
				{openDetails && !isEmpty(selectedPost) && fieldBy === "income_bank" &&
                    <BankSingle
                        bank={selectedPost} 
                        handleClose={this.handleClose} 
						income
                        {...this.props} 
                    />
                }
				
				<Grid container spacing={2}>
					<Grid item sm={6} xs={12}>
						<Box p={1} />
						<Box>
							{this.props.general &&
								<ButtonGroup color="secondary" disableElevation size="small">
									<Button
										onClick={() => this.props.changeFieldBy("income_post", "post_name")}
										variant={this.props.fieldBy === "income_post" ? "contained" : "outlined"} 
									>
										Postes
									</Button>
									<Button
										onClick={() => this.props.changeFieldBy("income_bank", "bank_name")}
										variant={this.props.fieldBy === "income_bank" ? "contained" : "outlined"} 
									>
										Banques
									</Button>
								</ButtonGroup>
							}
						</Box>
						<Box p={2} />
						<div className="chart" style={{maxWidth: "100%"}}>
							<Doughnut
								title={this.state.title}
								data={data}
								options={{
									title:{
										display:false,
									},
									legend:{
										display:false,
									}
								}}
							/>
						</div>
					</Grid>
					<Grid item sm={6} xs={12}>
						<List>
							<ListItem button>
								<ListItemText 
									primary={
										<Typography >
											Total
										</Typography>
									} 
								/>
								<ListItemSecondaryAction>
									<ListItemText secondary={<Typography color="primary" ><Currency value={Math.round(total * 100)/ 100} /></Typography>} />
								</ListItemSecondaryAction>
							</ListItem>
							<Divider />
							{Object.keys(listSum).map( 
								(itemName, i) => (
									<Fragment key={itemName}>
										<ListItem 
											button 
											onClick={ itemName !== "Autres Catégories" ? () => this.setState({openDetails: true, selectedPost: LIST[findKey(LIST, [fieldName, itemName])] }) : undefined }
										>
											<ListItemAvatar>
												<FiberManualRecord style={{color: bckg[i] ? bckg[i]: "grey" }}/>
											</ListItemAvatar>

											<ListItemText 
												primary={
													<Typography variant="body1">
														{catLabels[i]}
													</Typography>
												} 
												secondary={
													`${
														total > 0 
														? Math.round(listSum[itemName] / total * 100) 
														: 0
													}% - ${size(listQty[itemName])} transaction${size(listQty[itemName]) > 1 ? "s" : ""}`
												}
											/>
											<ListItemSecondaryAction>
												<ListItemText secondary={
													<Typography color="primary" variant="body2">
														<Currency value={listSum[itemName]} />
													</Typography>} />
											</ListItemSecondaryAction>
										</ListItem>
										<Divider />
									</Fragment>
								)
							)}
						</List>
					</Grid>
				</Grid>
			</div>
		)
	}
}

export default DoughnutChart